import React, { FC } from "react";
import { ButtonProps, Link as LinkThemeUI, LinkProps } from "theme-ui";

export const Link: FC<LinkProps> = ({ children, ...props }: LinkProps) => {
  const updatedProps = { ...props };
  if (!props.href || props.href.length <= 0) {
    delete updatedProps.href;
  }
  return (
    <LinkThemeUI variant="primary" {...updatedProps}>
      {children}
    </LinkThemeUI>
  );
};

export type LinkButtonProps = {
  href?: string;
} & ButtonProps;

export type ButtonSliderProps = {
  left?: boolean;
  href?: string;
} & ButtonProps;

export const linkButtonDefaultProps = {
  href: "#",
};

export const ButtonSliderDefaultProps = {
  left: true,
  href: "#",
};
